export default __webpack_public_path__ + "static/3-c23da442cacdc13c6f32a5a880539a63.png";